import { LicenseInfo } from '@mui/x-license';

/**
 * MUI X Premium license key.
 *
 * Prefer the build-time env var so the key can be rotated without a code change;
 * the literal stays as a fallback for local dev and CI where the var isn't set.
 */
const FALLBACK_LICENSE_KEY =
    'a25856da2deafb4941fff0c39c371685Tz0xMjI2NjEsRT0xNzk2MzQyMzk5MDAwLFM9cHJlbWl1bSxMTT1zdWJzY3JpcHRpb24sUFY9aW5pdGlhbCxLVj0y';

export const MUI_LICENSE_KEY: string =
    (import.meta.env?.VITE_MUI_LICENSE_KEY as string | undefined) ?? FALLBACK_LICENSE_KEY;

/**
 * Registers the license with MUI X. Must run before any Premium component renders —
 * that includes tests that mount a real DataGridPremium, hence the shared module.
 */
export function registerMuiLicense(): void {
    LicenseInfo.setLicenseKey(MUI_LICENSE_KEY);
}

